// AusProxies sells ProProxyUI servers only: the other server types are not offered in the admin screens.
// A server that already has another type keeps it in its own Edit window.
export const PPUI_ONLY = process.env.VUE_APP_VUE_NAME === 'ausproxies';
export const offeredTypes = (list, keep) => (PPUI_ONLY ? list.filter((t) => t === 'PROPROXYUI' || (keep && t === keep)) : list);
